import React from 'react'
import { RiAddCircleLine } from "react-icons/ri"
import { Link } from 'react-router-dom';
import Nav from '../Nav/Nav';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../api/api';
import { toast } from "react-toastify"

const ADDVARTMAN_URL = "api/vartman/addvartman"

function AddVartman() {

    const [englishtitle, Setenglishtitle] = useState();
    const [hindititle, Sethindititle] = useState("");
    const [englishpratik, Setenglishpratik] = useState("");
    const [hindipratik, Sethindipratik] = useState("");
    const [content, Setcontent] = useState("");
    const [introname, Setintroname] = useState("");
    const [introfather, Setintrofather] = useState("");
    const [intromother, Setintromother] = useState("");
    const [introkull, Setintrokull] = useState("");
    const [garbhplace, Setgarbhplace] = useState("");
    const [garbhtithi, Setgarbhtithi] = useState("");
    const [nakshatra, Setnakshatra] = useState("");
    const [janmplace, Setjanmplace] = useState("");
    const [janmtithi, Setjanmtithi] = useState("");
    const [loading, Setloading] = useState(false);
    const navigate = useNavigate();

    document.title = "Add Vartman Chaubisi - Jain Sadhana"

    const HandleAdd = async (event) => {
        Setloading(true)
        event.preventDefault();

        const data = { englishtitle, hindititle, englishpratik, hindipratik, content, introname, introfather, intromother, introkull, garbhplace, garbhtithi, janmplace, janmtithi, nakshatra }
        try {
            const response = await axios.post(ADDVARTMAN_URL, data)
            if (response.status === 200) {
                navigate('/vartmanlist')
                toast.success('Vartman Chaubisi Added Successfully')
                Setloading(false)
            }

        } catch (error) {
            console.log(error?.response?.data?.message)
            setTimeout(()=>Setloading(false),1000)
        }

    }



    return (
        <div className="container-fluid mt-3">
            <div className="row me-auto w-100">
                <div className="col-lg-3 px-4">
                    <Nav MasterTitleClass="active" vartman="text-white" />
                </div>
                <div className="col-lg-9">
                    <div className='font '>

                        {/* section 2 */}
                        <div className='container-fluid content-list-main-box mb-5' >
                            <div className=' position-relative content-box' >
                                <div className='d-flex mb-3 justify-content-between align-item-center' >
                                    <p className='list-page-title text-black text-capitalize'  >Add New vartman chaubisi</p>
                                    <Link to="/vartmanlist" className='text-black btn button-yellow text-capitalize back-list-button'>
                                        <i className='me-2' ><RiAddCircleLine /></i> List All vartman chaubisi</Link>
                                </div>
                                <div>
                                    <form onSubmit={HandleAdd}>
                                        <div className="row employ-form-list">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setenglishtitle(event.target.value)} className="form-control  bg-gray border border-0" id="englishtitle" name='englishtitle' placeholder="Vartman Chaubisi English Title" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">

                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Sethindititle(event.target.value)} className="form-control  bg-gray border border-0" id="hindititle" name='hindititle' placeholder="Vartman Chaubisi Hindi Title" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setenglishpratik(event.target.value)} className="form-control  bg-gray border border-0" id="englishpratik" name='englishpratik' placeholder="Pratik Chinh in English" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Sethindipratik(event.target.value)} className="form-control  bg-gray border border-0" id="hindipratik" name='hindipratik' placeholder="Pratik Chinh in Hindi" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12">

                                                        <div className="mb-3">
                                                            <textarea onChange={(event) => Setcontent(event.target.value)} style={{ height: "150px" }} className="form-control  bg-gray border border-0" id="content" name='content' placeholder="Vartman Chaubisi Content" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setintroname(event.target.value)} className="form-control  bg-gray border border-0" id="introname" name='introname' placeholder="Name" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setintrofather(event.target.value)} className="form-control  bg-gray border border-0" id="introfather" name='introfather' placeholder="Father's Name" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">

                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setintromother(event.target.value)} className="form-control  bg-gray border border-0" id="intromother" name='intromother' placeholder="Mother's Name" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setintrokull(event.target.value)} className="form-control  bg-gray border border-0" id="introkull" name='introkull' placeholder="Kull Name" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">

                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setgarbhplace(event.target.value)} className="form-control  bg-gray border border-0" id="garbhplace" name='garbhplace' placeholder="Garbh Place" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setgarbhtithi(event.target.value)} className="form-control  bg-gray border border-0" id="garbhtithi" name='garbhtithi' placeholder="Garbh tithi" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">

                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setnakshatra(event.target.value)} className="form-control  bg-gray border border-0" id="nakshatra" name='nakshatra' placeholder="Nakshatra" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setjanmplace(event.target.value)} className="form-control  bg-gray border border-0" id="janmplace" name='janmplace' placeholder="Janm Place" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">

                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setjanmtithi(event.target.value)} className="form-control  bg-gray border border-0" id="janmtithi" name='janmtithi' placeholder="Janm Tithi" required />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='d-flex  justify-content-center align-item-center mt-3' >
                                            {
                                                loading === true ? <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Loading... </button> : <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Submit</button>
                                            }
                                            <Link to={'/vartmanlist'} className='btn  bg-black font-size text-white  mx-3 px-4 py-2 ' ><i className="fa-solid fa-xmark  mx-2"></i>Cancel</Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AddVartman